import TechnologySimpleView from './TechnologySimpleView'

export default TechnologySimpleView
